module.exports = __webpack_public_path__ + "img/def.0e9c43ff.png";